



























































































  import Vue from "vue";
  import {Donation} from "@/interfaces/donation/donation";
  import { DeliveryMethod, Type } from '@/classes/DeliveryMethod';
  import { PaymentMethod } from '@/classes/PaymentMethod';
  import i18n from '@/plugins/i18n';

  export default Vue.extend({
    props: {
      donation: {
        type: Object as () => Donation,
        required: true
      },
      displayAdminFee: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {};
    },
    computed: {
      deliveryIsEmail(): boolean {
        return this.donation.deliveryMethod != null && this.donation.deliveryMethod.type === Type.EMAIL
      },
      adminAmount(): number {
        return this.donation.paymentSpecification.adminAmount ? this.donation.paymentSpecification.adminAmount : 0
      },
      totalAmount(): number {
        return parseInt(this.donation.paymentSpecification.causeAmount) + this.adminAmount
      },
      showAdminFee(): boolean {
        return this.displayAdminFee && this.donation.paymentSpecification && this.donation.paymentSpecification.adminAmount && this.donation.paymentSpecification.adminAmount > 0
      }
    },
    methods: {
      translatePaymentMethodName(paymentMethod: PaymentMethod): string {
        return i18n.translateEntityName(paymentMethod);
      },
      translateDeliveryMethodName(deliveryMethod: DeliveryMethod): string {
        return i18n.translateEntityName(deliveryMethod);
      }
    }
  });
